module.exports = __webpack_public_path__ + "assets/chrome.e0eaceb5.svg";